import React from "react";
import { formatCurrency } from "utils";
import { calculateTotal } from "modules/equipment";
import { Box, Stack, Typography } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { ListingForm } from "components/shared/TableListing/types";
import { RenderWithCondition } from "components/shared/Conditional/RenderWithCondition";
import { CHARGE_ROW_HEIGHT } from "../../../../constants/form";
import { QuoteChargeListingEntity, QuoteChargeType } from "../../../../types";

interface Props {
  rowIndex: number;
}

export const EquipmentChargeRowTotalCell = ({ rowIndex }: Props) => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();
  const { type, charge, equipment } = useWatch({ control, name: `bodyFields.${rowIndex}` });

  const renderCellContentByType: Record<QuoteChargeType, any> = {
    [QuoteChargeType.Invoice]: (
      <RenderWithCondition condition={!!charge}>
        <Typography>{formatCurrency(calculateTotal(charge!), true)}</Typography>
      </RenderWithCondition>
    ),
    [QuoteChargeType.Equipment]: (
      <Stack width="100%" height="100%" justifyContent="flex-end" gap="0.5rem">
        <Box height="100%">
          <Typography>{formatCurrency(calculateTotal(equipment?.price!), true)}</Typography>
        </Box>

        <RenderWithCondition condition={!!equipment?.attachments}>
          {equipment?.attachments.map(attachment => (
            <Box key={attachment.model} minHeight={CHARGE_ROW_HEIGHT}>
              <Typography>{formatCurrency(calculateTotal(attachment.price!), true)}</Typography>
            </Box>
          ))}
        </RenderWithCondition>
      </Stack>
    ),
  };

  return <>{renderCellContentByType[type]}</>;
};
